import React, { FC, useMemo } from 'react'
import { Icon, Slider, Table } from '@wmgtech/legato'

import { getUserBuild } from 'modulesCommon/Notifications/utils/getUserBuild'
import { ColumnsType } from '@wmgtech/legato/build/components/Table/types'
import { BrowserNotificationsProps } from './BrowserNotifications.props'

import './BrowserNotifications.scss'

const BrowserNotifications: FC<BrowserNotificationsProps> = ({ data, toggleSubscription }) => {
  const columns = useMemo<ColumnsType<unknown>[]>(
    () => [
      {
        dataIndex: 'push',
        key: 'push',
        title: 'Browser Push Notification',
        sortable: false,
        render: (record: any, { name }: any) => {
          return (
            <>
              <Icon prefix="fab" name={name} className="notifications__content-icon" />
              {getUserBuild()}
            </>
          )
        }
      },
      {
        dataIndex: 'status',
        key: 'status',
        title: 'Status',
        sortable: false,
        render: (record: any, { status, userId }: any) => (
          <Slider
            colorTypeOff="info"
            colorTypeOn="primary"
            size="md"
            onChange={(e) => toggleSubscription(e, userId)}
            checked={!!status}
          />
        )
      }
    ],
    [toggleSubscription]
  )

  return (
    <div>
      <div className="notifications__header">
        <h2 className="notifications__title">Browser Notifications</h2>
        <div>You'll receive notifications when new stories are published, even when you're not on Storybox.</div>
      </div>
      <div className="notifications__content">
        <Table
          className="notifications__content-table"
          rowKey={(record: any) => record.id}
          columns={columns}
          data={data}
          pagination={false}
        />
        <div className="notifications-info notifications-info--wide">
          <h3 className="notifications__title">Web Browser Notification</h3>
          Web browser notifications can be a great way to stay up-to-date on the latest news, updates, and information
          from Storybox. By turning on browser push notifications, you can receive these notifications as they happen,
          even when you're not actively using Storybox. And if you ever get tired of receiving notifications, you can
          easily turn them off again at any time. So if you're looking for a way to stay informed and up-to-date,
          browser push notifications are definitely worth considering.
        </div>
      </div>
    </div>
  )
}

export default BrowserNotifications
